import type { IconData } from '@stacksjs/iconify-core'

export const gbSct1x1: IconData = {
  "body": "<path fill=\"#0065bd\" d=\"M0 0h512v512H0z\"/><path stroke=\"#fff\" stroke-width=\".6\" d=\"m0 0l5 3M0 3l5-3\" transform=\"scale(102.4 170.66667)\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default gbSct1x1
